import gql from 'graphql-tag';
import contractFragment from 'ApolloClient/Fragments/contractFragment';

export default gql`
  mutation SignContractByClient($_id: ID!, $params: ContractParams) {
    signContractByClient(_id: $_id, params: $params) {
      ...contractFragment
      invoices {
        _id
        status
        due
      }
    }
  }
  ${contractFragment}
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Mutations/signContractByClient.js